<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">    
    <div v-if="!cancelled">
      <div>
        <Pagesubtitle v-if="!$store.getters['dash/subscription'].isTrialEnded"
          subTitle="Upgrade or downgrade at any time." />
      </div>

      <h3 v-if="$store.getters['dash/agency'].isClientName" class="font-medium my-3">{{ $store.getters['dash/agency'].isClientName }}</h3>
      <h3 v-else class="font-medium my-3">{{ $store.getters['dash/agency'].agencyName }}</h3>



      <div v-if="$store.state.dash.isMulti" class="p-4 my-3 rounded flex items-center lightbrandbg">
        <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
        <span class="font-medium">Your plan is shared between the following spaces:&nbsp;</span>
        {{ this.$store.state.dash.multiLocations.map(a => a.businessName).join(", ") }}
      </div>
      <vx-card v-if="$store.getters['dash/subscription'].isTrialEnded" class="mb-base w-full  py-10 text-center"
        style="border: 7px solid #F4E4F8;">
        <div class="w-100 mx-auto">
          <p class="mb-6">Thank you for trying Feedback Link!</p>
          <img class="w-32 pt_nofilter inline-block" src="@/assets/images/misc/thankyou.png" />
        </div>
        <h1 class="my-5">{{ $store.getters['dash/agency'].isClientName ?
          String($store.getters['dash/agency'].isClientName) + String('\'s trial') : 'Your free trial ' }} has ended.</h1>
        <p class="font-medium text-lg"
          v-if="!$store.state.dash.viewData.business.agencyParent && !$store.getters['dash/isCollaborator']">Select a plan
          below to continue using Feedback Link!</p>
        <p class="font-medium text-lg" v-else>
          <span v-if="$store.getters['dash/agency'].isClientName">Select a plan below to subscribe them to a plan. <p
              class="mt-5 text-light font-normal max-w-md mx-auto">Though the menu for this account is disabled, you can
              still manage other accounts by selecting "All Accounts >" at the top your dashboard.</p></span>
          <span v-else>Ask the creator of your account to subscribe to a Feedback Link plan!</span>
        </p>
      </vx-card>


      <div class="vx-row">
        <div class="vx-col flex md:w-2/3 w-full mt-2">
          <vx-card class="mb-base" v-if="!$store.getters['dash/isCollaborator']">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-2">
                <p>PLAN</p>
                <p class="font-medium text-3xl mb-4 text-primary" v-if="isLTDCustomer">Lifetime Plan</p>
                <p class="font-medium text-3xl mb-4 text-primary" v-if="$store.getters['dash/subscription'].isTrial">Trial
                  Plan</p>
                <p v-else class="font-medium text-3xl mb-4 text-primary">{{ $store.getters['dash/subscription'].planString
                }}</p>
                <p class="text-lg font-medium" v-if="$store.getters['dash/subscription'].isTrialEnded">
                  Free trial has ended
                </p>
                <p class="font-normal"
                  v-if="$store.getters['dash/subscription'].isTrial && $store.getters['dash/subscription'].trialDaysLeft !== 'ended'">
                  {{ $store.getters['dash/subscription'].trialDaysLeft + ' day' }}{{
                    $store.getters['dash/subscription'].trialDaysLeft > 1 ? 's ' : ' ' }} left of trial. Choose a plan below
                  to upgrade.
                </p>
              </div>
              <div class="vx-col md:w-1/2 w-full my-2">
                <p>SUBSCRIPTION</p>
                <p class="font-medium text-3xl mb-4 text-dark" v-if="!isMonthly">$0 p/m</p>
                <div v-else>
                  <p class="text-2xl mb-4 text-dark">
                    ${{ subscribedPlanAmount }} per month
                  </p>
                  <p>{{ $store.getters['dash/agency'].isClientName ? 'All client subscriptions p' : 'P' }}aid on day {{
                    subscriptionDayOfMonth }} of each month.</p>
                  <!-- STILL NEED TO DO YEARLY PLANS -->
                </div>
              </div>
            </div>



            <div class="my-3"
              v-if="!$store.getters['dash/subscription'].isTrial && !$store.state.dash.viewData.business.isOnFreePlan">
              <a href="mailto:support@feedback.link?subject=Plan Change">Change plan ></a>
            </div>
            <div class="my-3"
              v-if="!$store.getters['dash/subscription'].isTrial && !$store.state.dash.viewData.business.isOnFreePlan">
              <a href="mailto:support@feedback.link?subject=Plan Cancellation">Cancel plan ></a>
            </div>
          </vx-card>
        </div>




        <div class="vx-col flex md:w-1/3 w-full my-2" v-if="!isMonthly && !isLTDCustomer">
          <vx-card class="mb-base" v-if="!$store.getters['dash/isCollaborator']">
            <p>COUPON/DEAL CODE</p>
            <p class="my-4">Have a deal or coupon code? Enter it below to be processed.</p>
            <vs-input v-model="couponCode" class="w-full" placeholder="Enter code..." />
            <vs-button @click="processCouponCode" :disabled="couponCode.trim() === ''" class="w-full" type="line">Process
              Code</vs-button>
          </vx-card>
        </div>
       
      </div>      

      <vx-card
        v-if="isLTDCustomer && !$store.getters['dash/subscription'].isTrial && !$store.state.dash.viewData.business.isOnFreePlan"
        title="Addons" class="mb-base bg-white">
        <template slot="actions">
          <span>All currencies in USD</span>
        </template>
        <div class="vx-row" v-if="$store.getters['dash/addons'].subscribed">
          <div class="vx-col md:w-8/12 w-full">            
            <div>
              <p class="mt-1">
                <span class="font-medium text-2xl">✔️{{ $store.getters['dash/addons'].details.plan === 'videos' ? 'Video small' :  $store.getters['dash/addons'].details.plan === 'videom' ? 'Video medium' : 'Video large'  }}</span>
              </p>
              <p class="mt-2">
                <span class="block font-medium text-lg">{{ $store.getters['dash/addons'].details.planStreamingMins  }} minutes streaming p/m</span>
                <span class="block font-medium text-lg">{{ $store.getters['dash/addons'].details.planStorageMins  }} minutes storage</span>
              </p>
              <p class="mt-3 mb-5" v-if="!$store.getters['dash/addons'].details.isLTD">
                <span class="font-medium text-lg">${{ $store.getters['dash/addons'].details.monthlyPrice}} p/m</span>
              </p>
            </div>
            <div class="my-3" v-if="!$store.getters['dash/addons'].details.isLTD">
              <a href="mailto:support@feedback.link?subject=Addon Plan Change">Change plan ></a>
            </div>
            <div class="my-3" v-if="!$store.getters['dash/addons'].details.isLTD">
              <a href="mailto:support@feedback.link?subject=Addon Plan Cancellation">Cancel plan ></a>
            </div>
          </div>
        </div>
        <div class="vx-row" v-else>
          <div class="vx-col md:w-8/12 w-full">
            <div>
              <h3>Video testimonials</h3>
              <p class="my-4 text-lg">Good news — video testimonials are now <span class="font-medium">included in your plan</span>,
                at no extra cost. Capture Full HD video responses (up to 10 minutes each) and showcase them anywhere.</p>
              <p class="text-lg">There's nothing to buy. Just switch on video in any of your survey questions.</p>
            </div>
          </div>
        </div>
      </vx-card>


      <vx-card v-if="!isLTDCustomer"
        :title="isCustomer ? 'Plans' : !$store.state.dash.viewData.business.agencyParent && !$store.getters['dash/isCollaborator'] ? 'Subscribe now' : 'Plan Options'"
        class="mb-base text-center">
        <template slot="actions">
          <span>All currencies in USD</span>
        </template>
        <div class="vx-row md:pt-6 text-lg">
          <div class="vx-col mb-16 w-full md:w-1/2 lg:w-1/4 relative">
            <p class="text-primary absolute left-0 top-1up w-full" v-if="isCustomerPlan === '3m'">*Current Plan</p>
            <h2 class="my-6">Soar</h2>
            <div class="shadow-blue rounded">
              <div class="rounded-md py-8 rounded" style="background: #B3E2FC;">
                <div v-if="!$store.getters['dash/agency'].isAgency">
                  <span class="text-lg">$</span>
                  <span class="text-5xl mx-1 font-medium text-dark">{{ stripeSubDealCode ? Math.round((329 / 2) * 100) /
                    100 : '329' }}</span>
                  <span class="">/mo</span>
                  <p class="text-primary" v-if="stripeSubDealCode">*Discount applied*</p>
                </div>
                <div class="rounded py-0" v-else>
                  <div class="text-dark">
                  </div>
                  <div class="my-2">
                    <span class="text-lg">$</span>
                    <span class="text-5xl mx-1 font-semibold ">{{ Math.round(329 * (100 -
                      $store.getters['dash/agency'].agencySplit)) / 100 }}</span>
                    <span class="">/mo</span>
                    <p class="text-sm">{{ $store.getters['dash/agency'].agencySplit }}% revenue split</p>
                    <span class="text-sm">(Public $</span>
                    <span class="text-xl mx-1 font-medium">329</span>
                    <span class="text-sm">/mo)</span>
                  </div>
                </div>
              </div>
              <div class="py-8 px-6 rounded text-dark font-medium text-xl">
                <vs-button class="w-full my-2 mb-8" size="large"
                  v-if="!isCustomer && !$store.getters['dash/isCollaborator']"
                  @click="$router.push(`/dash/settings/plan/subscribe/soarmonthly?stripeSubDealCode=${stripeSubDealCode}`)">Subscribe</vs-button>
                <p class="mb-6 text-left" v-for="feature in planFeatures.soar.base">✔️ {{ feature }}</p>
                <vs-divider />
                <div class="extras font-bold px-4 text-left">
                  <p v-for="feature in planFeatures.soar.extra" class="my-6">+ {{ feature }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col mb-16 w-full md:w-1/2 lg:w-1/4 relative">
            <p class="text-primary absolute left-0 top-1up w-full" v-if="isCustomerPlan === '2m'">*Current Plan</p>
            <h2 class="my-6">Engage</h2>
            <div class="shadow-dark rounded" style="border: 2px dashed #4C4C4C;">
              <div class="rounded py-8 text-white" style="background: #4C4C4C;">
                <div v-if="!$store.getters['dash/agency'].isAgency">
                  <span class="text-lg">$</span>
                  <span class="text-5xl mx-1 font-medium">{{ stripeSubDealCode ? Math.round((69 / 2) * 100) / 100 : '69'
                  }}</span>
                  <span class="">/mo</span>
                  <p class="text-primary " v-if="stripeSubDealCode">*Discount applied*</p>
                </div>
                <div class="rounded py-0" v-else>
                  <div class="text-white">
                  </div>
                  <div class="my-2">
                    <span class="text-lg">$</span>
                    <span class="text-5xl mx-1 font-semibold ">{{ Math.round(69 * (100 -
                      $store.getters['dash/agency'].agencySplit)) / 100 }}</span>
                    <span class="">/mo</span>
                    <p class="text-sm">{{ $store.getters['dash/agency'].agencySplit }}% revenue split</p>
                    <span class="text-sm">(Public $</span>
                    <span class="text-xl mx-1 font-medium">69</span>
                    <span class="text-sm">/mo)</span>
                  </div>
                </div>
              </div>
              <div class="py-8 px-6 rounded text-dark font-medium text-xl">
                <vs-button size="large" class="w-full mt-2 mb-8"
                  v-if="!isCustomer && !$store.getters['dash/isCollaborator']"
                  @click="$router.push(`/dash/settings/plan/subscribe/engagemonthly?stripeSubDealCode=${stripeSubDealCode}`)">Subscribe</vs-button>
                <p class="mb-6 text-left" v-for="feature in planFeatures.engage.base">✔️ {{ feature }}</p>
                <vs-divider />
                <div class="extras text-left font-bold px-4">
                  <p v-for="feature in planFeatures.engage.extra" class="my-6">+ {{ feature }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col mb-16 w-full md:w-1/2 lg:w-1/4 relative">
            <p class="text-primary absolute left-0 top-1up w-full" v-if="isCustomerPlan === '1m'">*Current Plan</p>
            <h2 class="my-6">Learn</h2>
            <div class="shadow-green rounded">
              <div class="rounded py-8" style="background: #C2F2BE;">
                <div v-if="!$store.getters['dash/agency'].isAgency">
                  <span class="text-lg">$</span>
                  <span class="text-5xl mx-1 font-medium text-dark">{{ stripeSubDealCode ? Math.round((19 / 2) * 100) /
                    100 : '19' }}</span>
                  <span class="">/mo</span>
                  <p class="text-primary" v-if="stripeSubDealCode">*Discount applied*</p>
                </div>
                <div class="rounded py-0" style="background: #C2F2BE;" v-else>
                  <div class="text-dark">
                  </div>
                  <div class="my-2">
                    <span class="text-lg">$</span>
                    <span class="text-5xl mx-1 font-semibold ">{{ Math.round(19 * (100 -
                      $store.getters['dash/agency'].agencySplit)) / 100 }}</span>
                    <span class="">/mo</span>
                    <p class="text-sm">{{ $store.getters['dash/agency'].agencySplit }}% revenue split</p>
                    <span class="text-sm">(Public $</span>
                    <span class="text-xl mx-1 font-medium">19</span>
                    <span class="text-sm">/mo)</span>
                  </div>
                </div>
              </div>
              <div class="py-8 px-6 rounded text-dark font-medium text-xl">
                <vs-button class="w-full mt-2 mb-8" size="large"
                  v-if="!isCustomer && !$store.getters['dash/isCollaborator']"
                  @click="$router.push(`/dash/settings/plan/subscribe/learnmonthly?stripeSubDealCode=${stripeSubDealCode}`)">Subscribe</vs-button>
                <p class="mb-6 text-left" v-for="feature in planFeatures.learn.base">✔️ {{ feature }}</p>
                <div class="extras text-left font-bold px-4">
                  <p v-for="feature in planFeatures.learn.extra" class="my-6">+</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col mb-16 w-full md:w-1/2 lg:w-1/4 relative">
            <p class="text-primary absolute left-0 top-1up w-full" v-if="isCustomerPlan === '4m'">*Current Plan</p>
            <h2 class="my-6">Custom</h2>
            <div class="shadow-pink rounded">
              <div class="rounded py-8" style="background: #D372E5; min-height: 119px;">
                <span class="mt-6 font-medium text-xl inline-block">Enterprise and Franchise plans</span>
              </div>
              <div class="py-8 px-6 rounded text-dark font-medium text-lg">
                <vs-button size="large" v-if="!isCustomer && !$store.getters['dash/isCollaborator']" type="border"
                  class="w-full my-4" href="mailto:contact@feedback.link">Contact us</vs-button>
                <p class="fren">Reach out to us to hear about franchise and enterprise options.</p>
                <a type="border" class="w-full my-4 text-center block" href="mailto:contact@feedback.link">Contact us</a>
              </div>
            </div>
          </div>
        </div>
        <p class="w-full text-center my-10 text-xl">All plans includes brand customization and unlimited survey questions.
        </p>
      </vx-card>


      <vx-card class="bg-transparent w-full text-center my-5 p-5 text-dark text-lg">
        <div class="my-10 mx-auto w-full">
          <p class="my-2 max-w-xs mx-auto text-sm">We accept Visa, MasterCard, American Express, Discover and Diner’s
            Club.</p>
          <img src="@/assets/images/paymentmethods.png" class="w-80 mx-auto" />
        </div>
        <div class="my-10 mx-auto w-full">
          <img src="@/assets/images/stripe.png" class="h-10 mx-auto" />
          <p class="text-base my-2 font-medium">Payment securely processed by Stripe.</p>
        </div>
        <div class="max-w-md mx-auto">
          <p class="mt-5 font-medium">TRANSACTION SECURITY</p>
          <p>All transaction information passed between Feedback Link and Stripe's systems is encrypted using 256-bit SSL
            certificates. No cardholder information is ever passed unencrypted and any messages sent to our servers from
            Stripe are signed using MD5 hashing to prevent tampering.</p>

          <p class="mt-5 font-medium">ENCRYPTION & DATA STORAGE</p>
          <p>All sensitive data stored by Stripe Systems is secured using the same internationally recognised 256-bit
            encryption standards used by, among others, the US Government. The encryption keys are held on
            state-of-the-art, tamper proof systems in the same family as those used to secure VeriSign's Global Root
            certificate, making them all but impossible to extract. The data Stripe hold is extremely secure and they are
            regularly audited by banks and banking authorities to ensure it remains so.</p>

          <p class="mt-5">Feedback Link does not store any payment details. For more information please read our privacy
            policy.</p>
        </div>
      </vx-card>

      <vs-prompt title="Thank you for subscribing" @cancel="false" :buttonsHidden="true" :active.sync="showThanks">
        <div class="text-center py-10">
          <img src="@/assets/images/logo/smiley.png" class="w-32 my-4" />
          <h2 class="font-medium">You've subscribed successfully!</h2>
          <p class="text-primary my-4 text-lg font-medium">{{ !$store.getters['dash/agency'].isClientName ? 'You are now '
            : String($store.getters['dash/agency'].isClientName) + ' is now ' }} on the {{ $route.query.addon ? '"' + decodeURIComponent($route.query.addon) + '"' : $store.getters['dash/subscription'].planString }} plan.</p>
          <vs-button type="border" class="w-full my-4" @click="showThanks = false">Ok</vs-button>
        </div>
      </vs-prompt>

      <vs-prompt title="Thank you for purchasing" @cancel="false" :buttonsHidden="true" :active.sync="showThanksVideoLTD">
        <div class="text-center py-10">
          <img src="@/assets/images/logo/smiley.png" class="w-32 my-4" />
          <h2 class="font-medium">Video addon purchased</h2>
          <p class="text-primary my-4 text-lg font-medium">You are now on the Video Small plan.</p>
          <p class="font-medium">Please allow for a minute for plan to upgrade.</p>
          <vs-button type="border" class="w-full my-4" @click="showThanksVideoLTD = false">Ok</vs-button>
        </div>
      </vs-prompt>


    </div>
    <div v-else>
      <vx-card class="mb-base w-full  py-10 text-center" style="border: 7px solid #F4E4F8;">
        <div class="w-100 mx-auto">
          <p class="mb-6">Thank you for trying Feedback Link!</p>
          <img class="w-32 inline-block" src="@/assets/images/misc/thankyou.png" />
        </div>
        <h1 class="my-5">Your plan has been cancelled.</h1>
        <p class="font-medium text-lg">If you think this is an error, or would like to reinstate your account - please <a
            @click.prevent="chatToUs" class="cursor-pointer">talk to us</a>.</p>
      </vx-card>
    </div>





  </div>
</template>


<script>

/*

  Video discount for monthlies
   <vx-card class="mb-base pw-full" v-if="!$store.getters['dash/isCollaborator'] && isLTDCustomer && !$store.getters['dash/addons'].subscribed ">
            <vs-alert class="py-5 my-6 text-center w-full rounded text-dark" color="primary">
              <h5 class="font-medium my-4 text-2xl font-semibold">🎊 Thank you for your support, lifetime customer! 🎊</h5>
              <p class="text-lg my-4">For a limited time, we want to thank Lifetime deal subscribers with a <span
                  class="underline text-bold text-2xl">50% discount</span> on all video add-on plans. Use the below code.</p>
              <p class="text-center text-3xl my-6" v-if="LTDCustomerType === 'appsumo'">SUMOVIDEO23</p>
              <p class="text-center text-3xl my-6" v-if="LTDCustomerType === 'pitchground'">PGVIDEO23</p>
              <p class="text-center text-3xl my-6" v-if="LTDCustomerType === 'dealify'">DFYVIDEO23</p>
              <p class="text-center text-3xl my-6" v-if="LTDCustomerType === 'fbl'">FBLVIDEO23</p>
            </vs-alert>          
      </vx-card>

  FOR SELLING OUR OWN CODES:

  <vs-popup class="holamundo" title="Purchase Agency LTD Codes" :active.sync="showPurchaseLTDCoupon">          
    <h5 class="my-4">How many deal codes would you like to purchase?</h5>
    <div class="flex">
      <vs-input type="number" v-validate="'numeric|min-value:1'" name="Codes quantity" v-model="noCodesBuy" placeholder="Deal quantity"></vs-input>
      <span class="text-danger block mt-4">{{ errors.first('Codes quantity') }}</span>
      <vs-button class="ml-2">Checkout > </vs-button>
    </div>    
    <p>Total will be calculated at checkout.</p>
    <div class="con-vs-alert con-vs-alert-primary my-5">
       <h4 class="titlex vs-alert--title py-3">Important</h4>
     <div class="vs-alert text-lg py-4">
      <p class="mb-4">Agency codes purchased through us are non-refundable. Be sure to familiarise yourself/client with our software using the free trial, before you purchase.</p>    
      <p class="mb-4">Please note that our agency Lifetime deal offering is not available for any deal codes purchased from external platforms (Appsumo etc.)</p>      
     <p>You'll be taken to a secure Stripe-hosted checkout page to complete your purchase.</p>    
     <p></p>    
   </div>
   </div>
     <vs-collapse type="margin" :open-hover="true" class="small" >
           <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
             <div slot="header">
               Payment securely processed by Stripe.
             </div>
             <p>You will be forwarded to a secure payment page hosted by stripe.</p>
 <div class="my-10 w-full">
   <img src="@/assets/images/stripe.png" class="h-10 mx-auto block"/>
 </div>
 <div class="my-6 mx-auto w-full text-center">
   <p class="my-2 max-w-xs mx-auto text-sm">We accept Visa, MasterCard, American Express, Discover and Diner’s Club.</p>
   <img src="@/assets/images/paymentmethods.png" class="w-80 mx-auto"/>
 </div>      
 <div class="max-w-md mx-auto">
 <p class="mt-5 font-medium">TRANSACTION SECURITY</p>
 <p>All transaction information passed between Feedback Link and Stripe's systems is encrypted using 256-bit SSL certificates. No cardholder information is ever passed unencrypted and any messages sent to our servers from Stripe are signed using MD5 hashing to prevent tampering.</p>

 <p class="mt-5 font-medium">ENCRYPTION & DATA STORAGE</p>
 <p>All sensitive data stored by Stripe Systems is secured using the same internationally recognised 256-bit encryption standards used by, among others, the US Government. The encryption keys are held on state-of-the-art, tamper proof systems in the same family as those used to secure VeriSign's Global Root certificate, making them all but impossible to extract. The data Stripe hold is extremely secure and they are regularly audited by banks and banking authorities to ensure it remains so.</p>

 <p class="mt-5">Feedback Link does not store any payment details. For more information please read our privacy policy.</p>
 </div>  
           </vs-collapse-item>
         </vs-collapse>  
   <vs-divider class="my-4"/>                
   <div class="overflow-auto mt-4">
     <vs-button type="border" class="float-right" @click="() => {showAddCredits = false}">Cancel</vs-button>
   </div>
 </vs-popup>


*/

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  computed: {
    videoAddonPrices() {

      const currentChoice = this.videoChoice

      const calculated = {
        s: this.storePricing.videos,
        m: this.storePricing.videom,
        l: this.storePricing.videol        
      }      
      const orig = { ...calculated }

      //IF AGENCY,
      if (this.$store.getters['dash/agency'].isAgency) {
        const agencyDiscountPercentage = this.$store.getters['dash/agency'].agencySplit
        //apply agency discount:
        calculated.s = +((calculated.s * (1 - (agencyDiscountPercentage / 100))).toFixed(2));
        calculated.m = +((calculated.m * (1 - (agencyDiscountPercentage / 100))).toFixed(2));
        calculated.l = +((calculated.l * (1 - (agencyDiscountPercentage / 100))).toFixed(2));
      } else if (this.videoDiscount > 0) {
        calculated.s = +((calculated.s * (1 - (this.videoDiscount / 100))).toFixed(2));
calculated.m = +((calculated.m * (1 - (this.videoDiscount / 100))).toFixed(2));
calculated.l = +((calculated.l * (1 - (this.videoDiscount / 100))).toFixed(2));

      }

      calculated.current = currentChoice === '1' ? calculated.s : currentChoice === '2' ? calculated.m : calculated.l

      return {
        calculated,
        orig
      }

    },    
    subscribedPlanAmount() {

      let normal = 19


      const sSO = this.$store.state.dash.viewData.business.stripeSubscriptionObject

      if (typeof sSO === 'undefined') return 0

      let percentDiscount = sSO.discount ? sSO.discount.coupon.percent_off : false

      switch (this.$store.getters['dash/subscription'].plan) {
        case '1m':
          if (percentDiscount) normal = normal * (percentDiscount / 100)
          return this.$store.getters['dash/agency'].isAgency ? Math.round(19 * ((100 - this.$store.getters['dash/agency'].agencySplit))) / 100 : normal
          break
        case '2m':
          normal = 69
          if (percentDiscount) normal = Math.round(normal * (percentDiscount / 100) * 100)
          return this.$store.getters['dash/agency'].isAgency ? Math.round(69 * ((100 - this.$store.getters['dash/agency'].agencySplit))) / 100 : normal
          break
        case '3m':
          normal = 329
          if (percentDiscount) normal = Math.round(normal * (percentDiscount / 100) * 100)
          return this.$store.getters['dash/agency'].isAgency ? Math.round(329 * ((100 - this.$store.getters['dash/agency'].agencySplit))) / 100 : normal
          break
      }
      return false
    },
    subscriptionDayOfMonth() {
      let dOM = new Date(this.$store.state.dash.viewData.business.stripeSubscriptionObject.billing_cycle_anchor * 1000).getDate()
      return String(dOM)
    },
    cancelled() {
      let cancelled = false
      if (typeof this.$store.state.dash.viewData.business.cancelled !== "undefined") {
        if (this.$store.state.dash.viewData.business.cancelled) {
          cancelled = true
        }
      }
      return cancelled
    },
    showThanks: {
      get() {
        if (typeof this.$route.query.thankyou !== "undefined" && !this.hideShowThanks) {
          return true
        }
        return false
      },
      set() {
        this.hideShowThanks = true
        return
      }
    },
    LTDCustomerType() {
      if (!this.isLTDCustomer) return false
      if (this.$store.state.dash.viewData.business.isAppSumo) return 'appsumo'
      if (this.$store.state.dash.viewData.business.isPitchground) return 'pitchground'
      if (this.$store.state.dash.viewData.business.isDealify) return 'dealify'
      if (this.$store.state.dash.viewData.business.isFBLLTD) return 'fbl'
    },
    storePricing() {
      return this.$store.state.dash.pricing
    },
    isLTDCustomer() {
      return (this.$store.state.dash.viewData.business.isAppSumo || this.$store.state.dash.viewData.business.isPitchground || this.$store.state.dash.viewData.business.isDealify || this.$store.state.dash.viewData.business.isFBLLTD)
    },
    isMonthly() {
      return !(this.$store.getters['dash/subscription'].isTrial || this.$store.state.dash.viewData.business.isOnFreePlan || this.$store.state.dash.viewData.business.isAppSumo || this.$store.state.dash.viewData.business.isPitchground || this.$store.state.dash.viewData.business.isDealify || this.$store.state.dash.viewData.business.isFBLLTD)
    },
    isCustomer() {
      return !this.$store.getters['dash/subscription'].isTrial
    },
    isCustomerPlan() {
      if (this.isCustomer) {
        return this.$store.getters['dash/subscription'].plan
      }
      return false
    },
    planFeatures() {
      return this.$store.state.dash.planFeatures
    }
  },
  methods: {
    purchaseVideoLTD () {
      
        const data = {
          customerEmail: this.$store.getters['auth/userEmail']
        }      

    this.$vs.loading()

    this.$store.dispatch('dash/INITIATE_VIDEO_LTD_PURCHASE', data).then((r) => {

    //console.log('got response')
    //console.log(r)
  
    window.location.href = r.url

    this.$vs.loading.close()

    }).catch((e) => {

        this.$vs.loading.close()  

        this.$vs.notify({
          title: 'Purchase video LTD',
          text: 'Something went wrong, and we couln\'t initiate the purchase process. Please try again or reach out to support.',
          color: 'danger',
          time: 20000,
          iconPack: 'feather',
          icon: 'icon-info'
    })        

  })


},
    addVideo() {




    },
    processAddonCouponCode() {

      this.videoDiscount = 0

      this.$vs.loading()

      this.$store.dispatch('dash/PROCESS_DEAL_ADDON_CODE', {
        code: this.addonCouponCode,
        type: 'addon'
      }).then((res) => {

        if (res.data.valid) {
          if (res.data.type === 'video50') {
            //code is valid, apply discount                        
            this.videoDiscount = 50
            this.$vs.notify({
              title: 'Coupon applied',
              text: 'Discount has been applied.',
              color: 'success',
              time: 20000,
              iconPack: 'feather',
              icon: 'icon-check'
            })

          } else {

            this.$vs.notify({
              title: 'Code Invalid',
              time: 20000,
              text: 'Please double check your code text. Reach out to support if this issue continues.',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })

          }

        } else {
          this.$vs.notify({
            title: 'Code Invalid',
            time: 20000,
            text: 'Please double check your code text. Reach out to support if this issue continues.',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })

        }

        this.$vs.loading.close()

      }).catch(() => {

        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Isssue with code',
          time: 20000,
          text: 'Please double check your code text. Reach out to support if this issue continues.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })

    },

    processCouponCode() {


      this.$vs.loading()

      this.$store.dispatch('dash/PROCESS_DEAL_ADDON_CODE', {
        code: this.couponCode,
        type: 'plan'
      }).then((res) => {

        if (res.data.valid) {


          if (res.data.type === 'ltd') {


            //redirect          

            this.$router.push(`/dash/home?${res.data.partner}=true`)


          } else {


            if (res.data.type === 'partnersubdiscount') {

              if (this.$store.getters['dash/isAgency']) {

                this.$vs.notify({
                  title: 'Deal Code Invalid',
                  time: 20000,
                  text: 'Additional monthly subscription discount not available for agencies (your agency already has a monthly revenue split enabled).',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })


              } else {


                this.stripeSubDealCode = this.couponCode


                this.$vs.notify({

                  title: 'Coupon applied',
                  text: 'Discount has been applied. Click \'subscribe\' above your chosen plan to continue.',
                  color: 'success',
                  time: 20000,
                  iconPack: 'feather',
                  icon: 'icon-check'

                })


                this.couponCode = ''

              }


            }


          }

        } else {
          this.$vs.notify({
            title: 'Deal Code Invalid',
            time: 20000,
            text: 'Please double check your code text. Reach out to support if this issue continues.',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })


        }

        this.$vs.loading.close()


      }).catch(() => {

        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Deal Code',
          time: 20000,
          text: 'Please double check your code text. Reach out to support if this issue continues.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })

    }

  },
  created() {


    if (typeof this.$route.query['videoLTD'] !== 'undefined') {
      this.showThanksVideoLTD = true
    } 

    /*if (this.$route.query.purchaseltddeal) {
      this.showPurchaseLTDCoupon = true
    }*/

  },
  data() {
    return {
      //showPurchaseLTDCoupon: false,
      couponCode: '',
      noCodesBuy: 1,
      videoDiscount: 0,
      videoChoice: "1",
      addonCouponCode: "",
      hideShowThanks: false,
      showThanksVideoLTD: false,
      stripeSubDealCode: false
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  }
}
</script>

<style lang="scss"></style>
